// extracted by mini-css-extract-plugin
export var alignCenter = "_93-d";
export var bannerShown = "_93-6";
export var buttonContent = "_93-0";
export var cardList = "_93-1";
export var centerContent = "_93-2";
export var chevron = "_93-3";
export var closePanelButton = "_93-k";
export var conversationContextContainer = "_93-l";
export var conversationDetailContainer = "_93-4";
export var detailWrapper = "_93-7";
export var dropdownButton = "_93-e";
export var dropdownTitle = "_93-9";
export var fullHeight = "_93-5";
export var hidden = "_93-a";
export var icon = "_93-b";
export var mergeSuggestionWrapper = "_93-m";
export var panel = "_93-i";
export var portalButtonsWrapper = "_93-c";
export var right = "_93-j";
export var tableSummaryContainer = "_93-8";
export var tableSummaryHeader = "_93-g";
export var threeDotsButton = "_93-f";
export var wide = "_93-h";